module.exports = __webpack_public_path__ + "static/img/dayoff.c791def2.svg";